import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../Estilos/Principal.css';

const BarraNavegacion = () => {
  const location = useLocation(); // Esto obtiene la ruta actual

  return (
    <nav className="barra-navegacion">
      <div className="nombre-empresa">
        J&O COMUNICACIONES S.A.
      </div>
      <div className="logo">
        <img src="/Imagenes/logo.jpg" alt="Logo J&O" />
      </div>
      <div className="menu-derecha">
        {location.pathname === '/iniciar-sesion' ? (
          <Link to="/">
            <button className="btn-iniciar-sesion">Quiénes Somos</button>
          </Link>
        ) : (
          <Link to="/iniciar-sesion">
            <button className="btn-iniciar-sesion">Iniciar Sesión</button>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default BarraNavegacion;
